cv.LoginView = Marionette.LayoutView.extend({
  template: cv.Templates['auth/login'],

  events : {
    'click .auth-close' : 'authClose',
    'click .login' : 'login',
    'keyup input' : 'loginOnEnter',
    'click .remove-team' : 'removeTeam'
  },

  behaviors: [{
    behaviorClass: cv.FormBehavior,
    suppress_notifications : true
  }],

  validation: {
    login: [{
        required: 'true',
        msg: "Required"
    },{
        pattern: 'email',
        msg: 'Invalid e-mail'
    }],
    password: [{
        required: 'true',
        msg: "Required"
    }]
  },

  templateHelpers: function(){
    return {
      heading : this.heading,
      description : this.description,
      enable_registrations : cv.campaign.get('enable_registrations') == 1 ? true : false
    };
  },

  initialize: function(options){
    this.options = _.extend(this.options, options);
    this.heading = 'Fundraiser Login';
    this.description = 'Manage your personal fundraising page';

    // Determine if we are in a window or not
    if(window.name != 'auth'){
      this.in_iframe = false;
    }else{
      this.in_iframe = true;
    }

    // Grab the IP address and set it on the model
    $.getJSON("https://api.ipify.org?format=jsonp&callback=?",
      _.bind(function(json){
        this.model.set('ip_address', json.ip);
      },this)
    );

    // Set a default
    if(_.isUndefined(this.options.params.team_id)){
      this.options.params.team_id = null;
    }

    // Login trigger
    this.listenTo(this, 'form:saved', function(){
      vent.trigger('notif:success', 'Logging in...');
      
      $.ajax({
        url: cv.api_path + '/auth/login',
        dataType: "json",
        data: {
          login : this.model.get('login'),
          password : this.model.get('password'),
          campaign_id : cv.campaign.get('id'),
          team_id : this.options.params.team_id
        },
        type: "post",
        success: _.bind(function(data){
          if(data.project_stub != ''){
            top.location = '/' + data.project_stub + '/admin/dashboard';
          }else{
            top.location = '/fundraiser_setup';
          }
        }, this),
        error: _.bind(function(data){
          if($.parseJSON(data.responseText).data == 'need_invite_code'){
            // Just replace the view with invite
            var contentRegion = cv.rootView.getRegion('content');
            var authRegion = contentRegion.currentView.getRegion('auth');
            authRegion.show(new cv.InviteView({
              heading : this.heading,
              description : this.description,
              team_id : this.options.params.team_id,
              model : this.model
            }));
          }else{
            Backbone.Validation.error(this, 'login', 'Invalid');
            Backbone.Validation.error(this, 'password', 'Invalid');
            vent.trigger('notif:error', $.parseJSON(data.responseText).data);
          }
        }, this)
      });
    }, this);

    this.listenTo(this, 'form:changed', function(model){
    }, this);

    this.listenTo(this, 'form:has_errors', function(){
      vent.trigger('notif:error', 'Please fix the errors on this form.');
    }, this);

    console.log('LoginView initialized.');
  },

  authClose: function(e){
    e.preventDefault();

    // Close the items, must delay until after animation
    $('body').addClass('hidden');
    setTimeout(_.bind(function(){
      window.top.postMessage("close-auth", "*");
    }, this), 250);
  },

  loginOnEnter: function(e) {
    e.preventDefault();

    // If we don't hit enter, then do nothing
    if (e.keyCode != 13) return;

    this.$('#login, #password').change();

    this.login(e);
  },

  login: function(e){
    e.preventDefault();
    e.stopPropagation();

    this.trigger('form:save');
  },

  removeTeam: function(e){
    e.preventDefault();

    this.$('.team').remove();
    this.options.params.team_id = null;
    window.history.replaceState(null, null, window.location.pathname);
    this.$('.signup-link').attr('href', this.$('.signup-link')[0].pathname);
  },

  onShow: function(){
    // Change document title
    document.title = 'Fundraiser Login';
    
    if(!_.isNull(this.options.params.team_id)){
      // Add the team to the top of the form
      this.$('form').prepend('<div class="team form-group"></div>')
      $.ajax({
        url: cv.api_path + '/teams/' + this.options.params.team_id,
        dataType: "json",
        data: {
        },
        type: "get",
        success: _.bind(function(data){
          this.$('.team').html(cv.Templates['auth/team']({
            photo_path : cv.photo({
              photo_path : data.data.photo_path,
              transforms : {
                fit : 'crop'
              },
              url_only : true
            }),
            name : data.data.name
          }));

          imgix.fluid(this.$el.get(0), {
            rootNode: this.$el.get(0),
            updateOnResizeDown: false,
            autoInsertCSSBestPractices: true
          });
        }, this),
        error: _.bind(function(data){
         
        }, this)
      });

      // Add the query string param to the login
      this.$('.signup-link').attr('href', this.$('.signup-link')[0].pathname + '?team_id=' + this.options.params.team_id);
    }
  }
});
